import { useEffect } from 'react';
import { pageTitle } from './product';

/** Sets `document.title` for the route ("Home — AdOrchestrator"); screen readers announce it on navigation. */
export function usePageTitle(route: string): void {
  useEffect(() => {
    document.title = pageTitle(route);
  }, [route]);
}
